import camelToUnderLine from "./camelToUnderline";
import underlineToCamel from "./underlineToCamel";
export default {
    camelToUnderLine,
    underlineToCamel
};
export { camelToUnderLine, underlineToCamel };
